import React from 'react';

interface Props {
    message: string
}
const ErrorAlertView = (props: Props) => {
    return (
        <div className="alert alert-danger">
            {props.message}
        </div>
    )
}

export default ErrorAlertView;
